import { render, staticRenderFns } from "./ParcoursModalContentSkeleton.vue?vue&type=template&id=75efa04a&scoped=true&"
import script from "./ParcoursModalContentSkeleton.vue?vue&type=script&lang=js&"
export * from "./ParcoursModalContentSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursModalContentSkeleton.vue?vue&type=style&index=0&id=75efa04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75efa04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VContainer,VIcon,VSkeletonLoader})
